import { render, staticRenderFns } from "./loyalty-receipt.vue?vue&type=template&id=4ab3a95e&scoped=true"
import script from "./loyalty-receipt.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-receipt.ts?vue&type=script&lang=ts&external"
import style0 from "./loyalty-receipt.scss?vue&type=style&index=0&id=4ab3a95e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3a95e",
  null
  
)

export default component.exports